module.exports = __webpack_public_path__ + "static/media/wide.785dbcd0.jpg";